// TODO: update this
const EXAMPLE_PROJECT_ID = "Example Project Test 2";
export default EXAMPLE_PROJECT_ID;
